module.exports = __webpack_public_path__ + "assets/8417f46691e90eceda114e3fce940931.png";